var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChallengesEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.1668 6.6665H23.8335V28.9702C23.8335 37.8809 28.5087 46.1383 36.1496 50.7229C38.8275 52.3296 42.1729 52.3296 44.8507 50.7229C52.4916 46.1383 57.1668 37.8809 57.1668 28.9702V6.6665Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 6.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5 73.3335H20.5V70.4865C20.5 68.1456 21.8226 66.0055 23.9164 64.9586C34.356 59.7388 46.644 59.7388 57.0836 64.9586C59.1774 66.0055 60.5 68.1455 60.5 70.4865V73.3335Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 6.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1665 16.6665H73.8332C73.8332 33.3332 70.4998 43.3332 70.4998 43.3332",
    stroke: "currentColor",
    strokeWidth: 6.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8335 16.6665H7.16683C7.16683 33.3332 10.5002 43.3332 10.5002 43.3332",
    stroke: "currentColor",
    strokeWidth: 6.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 53.3335V60.0002",
    stroke: "currentColor",
    strokeWidth: 6.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengesEmptyState);
export default __webpack_public_path__ + "static/media/challenges-empty-state.e288e1697d29a3d71ec686c370f6adbe.svg";
export { ForwardRef as ReactComponent };